/**
 * Add item: immediate add when one type allowed; dropdown menu when several.
 */

import * as React from 'react';
import {
    Button,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
    cn,
} from '@ai-content-hub/content-kit';
import { Plus } from 'lucide-react';

export interface CompositeEditAddQuestionOption {
    id: string;
    label: string;
}

export interface CompositeEditAddQuestionButtonProps {
    options: CompositeEditAddQuestionOption[];
    onAdd: (typeId: string) => void;
    disabled?: boolean;
    className?: string;
    /** e.g. "Add question" / "Add exercise" */
    label: string;
}

export function CompositeEditAddQuestionButton({
    options,
    onAdd,
    disabled = false,
    className,
    label,
}: CompositeEditAddQuestionButtonProps): React.ReactElement {
    if (options.length === 0) {
        return (
            <Button
                type="button"
                className={cn('w-full mt-2', className)}
                disabled
                variant="default"
            >
                <Plus className="h-4 w-4 mr-2" />
                {label}
            </Button>
        );
    }

    if (options.length === 1) {
        const only = options[0];
        return (
            <Button
                type="button"
                className={cn('w-full mt-2', className)}
                disabled={disabled}
                variant="default"
                onClick={() => onAdd(only.id)}
            >
                <Plus className="h-4 w-4 mr-2" />
                {label}
            </Button>
        );
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    type="button"
                    className={cn('w-full mt-2', className)}
                    disabled={disabled}
                    variant="default"
                >
                    <Plus className="h-4 w-4 mr-2" />
                    {label}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="min-w-[200px]">
                {options.map((opt) => (
                    <DropdownMenuItem
                        key={opt.id}
                        className="cursor-pointer"
                        onClick={() => onAdd(opt.id)}
                    >
                        {opt.label}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
